import React, { useState, useEffect } from 'react'
import SelectStudent from '../../components/SelectStudent'
import { Container, Box, Grid, TextField, Typography, Button, Divider } from '@mui/material/'
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';
import CreateIcon from '@mui/icons-material/Create';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CreateStudent from '../../components/CreateStudent'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useFetch } from '../../hooks/useFetch'
import ViewQuote from '../../components/purchase/ViewQuote'
import ViewDelivery from '../../components/purchase/ViewDelivery'
import ViewTerms from '../../components/purchase/ViewTerms'
import ViewOrder from '../../components/purchase/ViewOrder'
import { useLogout } from '../../hooks/useLogout'
import LogoutIcon from '@mui/icons-material/Logout';
function PurchaseCourse() {

    const { logout } = useLogout()
    const { accessLevel, parentID, user } = useAuthContext()
    const { postData, error, isPending, errorMessage, data: newQuote } = useFetch('https://dcregapi.bi-oss.co.za/quote/create', 'POST')


    //states for view
    const [selectStudent, setSelectStudent] = useState(1)
    const [createStudent, setCreateStudent] = useState(0)
    const [viewDelivery, setViewDelivery] = useState(0)
    const [viewQuote, setViewQuote] = useState(0)
    const [viewTerms, setViewTerms] = useState(0)
    const [viewOrder, setViewOrder] = useState(0)

    //variable states
    const [studentId, setStudentId] = useState('')
    const [quoteId, setQuoteId] = useState('')
    const [orderId, setOrderId] = useState('')
    const [returnChecksum, setReturnCheckSum] = useState('')
    const [paymentReqId, setPaymentReqId] = useState('')
    const [total, setTotal] = useState('')
    const handleSubmit = (e) => {
        e.preventDefault()
        postData({
            createdBy: user.email,
            parentId: parentID,
            studentId
        })

    }

    useEffect(() => {
        if (newQuote) {
            setQuoteId(newQuote.quoteId)
            setViewQuote(1)
        }
    }, [newQuote])

    return (
        <>


            {new Date().getMonth() === 7 && (

                <Container maxWidth="md"  >




                    <Box mb={5} />
                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: 'primary.main', borderRadius: 2 }}>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                    Purchase BIDC Courses
                                </Typography>



                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    British International Distance College courses are currently unavailable for purchase during the month of September. From 1 October, the new academic year courses will be available for purchase.
                                </Typography>



                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >

                                        <Button fullWidth onClick={(e) => logout()} color="primary" variant="contained">Logout<LogoutIcon /></Button>


                                    </Box>

                                </Grid>
                            </Box>
                            <Box mb={5} />
                        </Grid>

                    </Grid>
                </Container>
            )}
            {!viewOrder && !viewTerms && !viewDelivery && !viewQuote && !createStudent && selectStudent && new Date().getMonth() !== 7 && (


                < Container maxWidth="md"  >
                    <form onSubmit={handleSubmit} autoComplete="off" >



                        <Box mb={5} />
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: 'primary.main', borderRadius: 2 }}>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                        Purchase BIDC Courses
                                    </Typography>



                                </Box>


                            </Grid>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >

                                    {new Date().getMonth() >= 8 && (


                                        <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                            {new Date().getFullYear() + 1} courses are available for purchase.
                                        </Typography>

                                    )}

                                    {new Date().getMonth() < 8 && (


                                        <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                            {new Date().getFullYear()} courses are available for purchase.
                                        </Typography>

                                    )}


                                </Box>


                            </Grid>









                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >


                                    <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                        To purchase a course, select the student you would like to register and then click the continue button.
                                    </Typography>



                                </Box>


                            </Grid>
                            {errorMessage && (

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" className='error' fullWidth sx={{ textAlign: 'center' }}>
                                            {errorMessage}
                                        </Typography>
                                    </Box>

                                </Grid>
                            )}

                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <SelectStudent studentId={studentId} setStudentId={setStudentId} />


                                </Box>

                            </Grid>


                            <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}

                                >

                                    {studentId && (

                                        <Button fullWidth type="submit" color="primary" variant="contained">Continue<SendIcon /></Button>
                                    )}
                                    {!studentId && (

                                        <Button fullWidth disabled color="primary" variant="contained">Continue<SendIcon /></Button>
                                    )}

                                </Box>

                            </Grid>
                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >


                                    <Divider style={{ width: '100%', color: "primary.main" }} />
                                </Box>

                            </Grid>


                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >


                                    <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                        If you are not linked to an active student, click the Create Student button and follow the registration process.
                                    </Typography>



                                </Box>


                            </Grid>

                            <Grid item xs={12}>

                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    sx={{

                                        maxWidth: '95%',
                                        marginLeft: 'auto',
                                        marginRight: 'auto'
                                    }}
                                >
                                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                        <Box
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{

                                                maxWidth: '95%',
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                            }}

                                        >

                                            <Button fullWidth onClick={(e) => setCreateStudent(1)} color="primary" variant="contained">Create Student<CreateIcon /></Button>


                                        </Box>

                                    </Grid>
                                </Box>
                                <Box mb={5} />
                            </Grid>





                        </Grid>

                    </form>
                </Container>



            )}

            {createStudent === 1 && (
                <>
                    <CreateStudent setCreateStudent={setCreateStudent} />
                </>

            )}
            {viewQuote === 1 && (

                <ViewQuote studentId={studentId} setViewQuote={setViewQuote} quoteId={quoteId} setViewDelivery={setViewDelivery} setSelectStudent={setSelectStudent} />
            )}

            {viewDelivery === 1 && (

                <>
                    <ViewDelivery studentId={studentId} setViewDelivery={setViewDelivery} quoteId={quoteId} setViewTerms={setViewTerms} />
                </>
            )}
            {viewTerms === 1 && (
                <>

                    <ViewTerms setOrderId={setOrderId} setViewTerms={setViewTerms} setViewOrder={setViewOrder} quoteId={quoteId} setReturnCheckSum={setReturnCheckSum} setPaymentReqId={setPaymentReqId} setTotal={setTotal} />
                </>
            )}

            {viewOrder === 1 && (

                <>


                    <ViewOrder orderId={orderId} studentId={studentId} paymentReqId={paymentReqId} returnChecksum={returnChecksum} total={total} setViewOrder={setViewOrder} />
                </>
            )}

        </>
    )
}

export default PurchaseCourse